import { MessageCircle, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { waLink } from "@/lib/content";

const PILLS = [
  "Check Availability for 2026",
  "Inquire About Group Bookings",
  "Request Private Chef Package",
];

export const FinalCTA = ({ config }) => (
  <section id="contact" className="relative overflow-hidden bg-ink py-28 text-ivory sm:py-36 lg:py-44" data-testid="final-cta-section">
    <div
      className="pointer-events-none absolute inset-0 opacity-[0.07]"
      style={{
        backgroundImage:
          "url(https://images.unsplash.com/photo-1675657144285-7daf131132de?auto=format&fit=crop&w=1600&q=60)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    />
    <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
      <Reveal>
        <p className="mb-6 flex items-center justify-center gap-3 text-[11px] font-medium uppercase tracking-[0.3em] text-ivory/50">
          <span className="h-px w-10 bg-gold" /> Begin Your Stay <span className="h-px w-10 bg-gold" />
        </p>
        <h2 className="font-serif text-4xl font-light leading-[1.05] tracking-tight sm:text-6xl lg:text-7xl">
          Ready for <span className="italic text-gold">Private Bali</span> Luxury?
        </h2>
        <p className="mx-auto mt-8 max-w-xl text-sm font-light leading-relaxed text-ivory/60 sm:text-base">
          Connect directly with our villa concierge on WhatsApp for real-time
          rates, custom dates, and instant booking confirmation.
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <a
          data-testid="final-whatsapp-cta"
          href={waLink(config.whatsapp_number, config.whatsapp_default_message)}
          target="_blank"
          rel="noopener noreferrer"
          className="group mt-12 inline-flex items-center gap-4 bg-gold px-10 py-5 text-xs font-semibold uppercase tracking-[0.22em] text-ink transition-colors duration-500 hover:bg-ivory"
        >
          <MessageCircle size={17} className="transition-transform duration-500 group-hover:-rotate-12" />
          Message Our Concierge
        </a>
      </Reveal>

      <Reveal delay={0.25}>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          {PILLS.map((pill, i) => (
            <a
              key={pill}
              data-testid={`quick-pill-${i}`}
              href={waLink(config.whatsapp_number, `Hi BALIBIGVILLAS, ${pill.toLowerCase()}.`)}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-2 border border-ivory/25 px-5 py-2.5 text-[11px] font-light tracking-wide text-ivory/70 transition-colors duration-500 hover:border-gold hover:text-gold"
            >
              {pill}
              <ArrowUpRight size={12} className="transition-transform duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </a>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
